import { useTranslation } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as React from "react";
import { products } from "../../content/products.js";
import { sectionClass } from "../../config/sectionClasses.js";
import { Reveal } from "../Reveal.jsx";
import { sectionHeaderClass } from "../../config/sectionClasses.js";
var subtitleClass = "Products_pmCardSubtitle__fNrXd";
function Products() {
  let { t: translate, i18n: i18n } = useTranslation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    isChinese = i18n.language?.startsWith("zh"),
    [activeProductKey, setActiveProductKey] = (0, React.useState)(
      products[0].key,
    );
  return (
    <section className={sectionClass}>
      <Reveal>
        <div className={sectionHeaderClass}>
          <h2>{translate("home.products.title")}</h2>
        </div>
      </Reveal>
      <Reveal>
        <div className={"Products_pmAccordion__fNrXd"}>
          {products.map((t) => {
            let l = t.key === activeProductKey;
            return (
              <div
                key={t.key}
                className={`Products_pmCard__fNrXd ${l ? "Products_pmCardActive__fNrXd" : ""}`}
                onMouseEnter={() => setActiveProductKey(t.key)}
                onClick={() => setActiveProductKey(t.key)}
              >
                <div className={"Products_pmCardHeader__fNrXd"}>
                  <span className={"Products_pmCardTitle__fNrXd"}>
                    {translate(`home.products.${t.key}.short`)}
                  </span>
                  <a
                    href={t.href}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    className={"Products_pmCardTryBtn__fNrXd"}
                    onClick={(n) => {
                      (n.stopPropagation(),
                        track("track", "home_prodmetrix_click", {
                          button: t.trackName,
                          title: translate(`home.products.${t.key}.title`),
                        }));
                    }}
                  >
                    {translate(`home.products.${t.key}.btn`)}
                    <svg
                      width={"14"}
                      height={"14"}
                      viewBox={"0 0 14 14"}
                      fill={"none"}
                    >
                      <path
                        d={"M3 11L11 3M11 3H5.5M11 3V8.5"}
                        stroke={"currentColor"}
                        strokeWidth={"1.5"}
                        strokeLinecap={"round"}
                        strokeLinejoin={"round"}
                      />
                    </svg>
                  </a>
                  <button
                    type={"button"}
                    className={"Products_pmCardExpandBtn__fNrXd"}
                    aria-expanded={l}
                    aria-label={translate(`home.products.${t.key}.title`)}
                    onClick={(e) => {
                      (e.stopPropagation(), setActiveProductKey(t.key));
                    }}
                  >
                    <svg
                      width={"12"}
                      height={"12"}
                      viewBox={"0 0 12 12"}
                      fill={"none"}
                      aria-hidden={"true"}
                    >
                      <path
                        fillRule={"evenodd"}
                        clipRule={"evenodd"}
                        d={
                          "M10.2539 4.71875L9.5468 4.01164L6.01127 7.54718L2.47573 4.01164L1.76863 4.71875L5.65768 8.60781L6.01127 8.96139L10.2539 4.71875Z"
                        }
                        fill={"currentColor"}
                      />
                    </svg>
                  </button>
                </div>
                <div className={"Products_pmCardBody__fNrXd"}>
                  <p
                    className={`${subtitleClass} Products_pmSubExpanded__fNrXd`}
                  >
                    {translate(`home.products.${t.key}.desc`)}
                  </p>
                  <p
                    className={`${subtitleClass} Products_pmSubCollapsed__fNrXd`}
                  >
                    {translate(`home.products.${t.key}.tag`)}
                  </p>
                </div>
                <div className={"Products_pmCardPreview__fNrXd"}>
                  <div className={"Products_pmCardPreviewInner__fNrXd"}>
                    <img
                      className={"Products_pmImgExpanded__fNrXd"}
                      src={`images/product-matrix/${!isChinese && t.imageEn ? t.imageEn : t.image}.png`}
                      alt={translate(`home.products.${t.key}.title`)}
                      loading={"lazy"}
                    />
                    <img
                      className={"Products_pmImgCollapsed__fNrXd"}
                      src={`images/product-matrix/${t.imageCollapsed}.png`}
                      alt={""}
                      aria-hidden={"true"}
                      loading={"lazy"}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}
export { subtitleClass, Products };
